document.addEventListener('DOMContentLoaded', async function() {
    if (window.scriptInitialized) return;
    window.scriptInitialized = true;
    const shopUrl = Shopify.shop;
    const braSizes = document.getElementById('bra-sizes');
    const band_size = braSizes.getAttribute('band_size');
    const cup_size = braSizes.getAttribute('cup_size');
    const fetchProductDetails = async (tag) => {
        const storefrontAccessToken = "e37d6f5fced72df1026762e8fcf43b21";
        const url = `https://${shopUrl}/api/2024-10/graphql.json`;
    
        const productQuery = `
                query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                    products(first: 100, query: $query) {
                        edges {
                            node {
                                id
                                title
                                handle
                                discontinued: metafield(namespace: "custom", key: "discontinued") {
                                    value
                                    type
                                }
                                variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                    value
                                    type
                                }
                                totalInventory
                                priceRange {
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                images(first: 2) {
                                    edges {
                                        node {
                                            src
                                            altText
                                        }
                                    }
                                }
                                variants(first: 100) {
                                    edges {
                                        node {
                                            id
                                            title
                                            quantityAvailable
                                            compareAtPrice {
                                                amount
                                                currencyCode
                                            }
                                            selectedOptions {
                                                name
                                                value
                                            }
                                            image {
                                                src
                                                altText
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `;
    
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    query: productQuery,
                    variables: {
                        query: `tag:${tag}`,
                        country: Shopify.country,
                    },
                })
            });
        
            const { data, errors } = await response.json();
        
            if (errors) {
                console.error("GraphQL Errors:", errors);
                return null;
            }
        
            if (data && data.products.edges) {
                const productDetails = data.products.edges.map(({ node }) => {
                    if (node) {
                        return node;
                    } else {
                        console.warn("Encountered a null product.");
                        return null;
                    }
                }).filter(Boolean);

                return productDetails;
            } else {
                console.warn("No product data found.");
                return null;
            }
        } catch (error) {
          console.error("Error fetching product:", error);
          return [];
        }
    };
    const enableDigiohSwatch = async () => {
        const swatches = document.querySelectorAll('.product-card-swatch');
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          const productCard = this.closest('.product-card');
          const primaryImage = productCard.querySelector('.product-primary-image');
          const secondaryImage = productCard.querySelector('.product-secondary-image');
          const currentVariantId = productCard.querySelector('#current_variant_id');
          const productCardTitleHref = productCard.querySelector('.product-card-title');
           const productCardImgHref = productCard.querySelector('.product-featured-image a');
    
          if (this.hasAttribute('data-srcset')) {
            let newPrimarySrcset = this.getAttribute('data-srcset') || '';
            if (!newPrimarySrcset) {
                newPrimarySrcset = '/cdn/shop/t/1/assets/natoriplaceholder.png';
            }
            if (primaryImage) {
              primaryImage.srcset = newPrimarySrcset;
              primaryImage.src = newPrimarySrcset.split(' ')[0];
            }
          }
          if (this.hasAttribute('data-srcset-2')) {
            const newSecondarySrcset = this.getAttribute('data-srcset-2');
            if (secondaryImage) {
              secondaryImage.srcset = newSecondarySrcset;
              secondaryImage.src = newSecondarySrcset.split(' ')[0];
            }
          }

          if (this.hasAttribute('data-variant_id')) {
            const newVariantId = this.getAttribute('data-variant_id');
            if (newVariantId) {
              currentVariantId.value = newVariantId;
            }
          }
          if (this.hasAttribute('data-href')) {
            const product_handle = this.getAttribute('data-href');
            if (product_handle) {
                productCardTitleHref.setAttribute('href', product_handle);
                productCardImgHref.setAttribute('href', product_handle);
            }
          }

          swatches.forEach(s => s.classList.remove('active'));
          this.classList.add('active');
        });
      });
    }
    const processProductDetails = async (
        product,
        keyArray,
        valArray,
        featuredImageId,
        productDataElements,
        productId,
        primaryImagesrc,
        secondaryImagesrc,
        mainHandle,
        uniqueColors,
        counter,
        productAvailable
    ) => {
        if (product && product.variants && product.variants.edges) {
            let storedVariants = JSON.parse( "{}" );
            let customVarList = storedVariants[productId]?.variants || [];
            for (const edge of product.variants.edges) {
                const variant = edge.node;
                const productQuan = productAvailable;
                if (variant) {
                    let variantCustomId = parseInt(variant.id.split("/").pop());
                    if (!customVarList.includes(variantCustomId)) {
                        if ( variant.selectedOptions[1].value == band_size && variant.selectedOptions[2].value == cup_size){
                            for (const option of variant.selectedOptions) {
                                if ( option.name.toLowerCase() === "color" || option.name.toLowerCase() === "colour" || option.name.toLowerCase() === "couleur" ) {
                                    const key = option.value;
                                    if (!uniqueColors.has(key) && counter.count < 6) {
                                        uniqueColors.set(key, option);
                                        if (option.value.length > 0) {
                                            let swatchHtml = "";
                                            let active = "";
                                            let variantImage = "";
                                            let variantUrl = "";
                                            let srcset = "";
                                            let variantId = parseInt(variant.id.split("/").pop());
                                            if (variant) {
                                                if (variantId === featuredImageId) {
                                                    active = "active";
                                                }
                                                if (primaryImagesrc) {
                                                    variantImage = primaryImagesrc;
                                                }
                                                variantUrl = `/products/${product.handle}?variant=${variantId}`;
                                            }
                                            const imageSizes = "{{ sizes }}".split(",");
                        
                                            if (variantImage) {
                                                imageSizes.forEach((size) => {
                                                    const sizeArray = size.split("x");
                                                    const sizeX = sizeArray[0] + "x" + (sizeArray[1] !== "0" ? sizeArray[1] : "");
                                                    srcset += `${variantImage.replace(".jpg", `_${sizeX}.jpg`)} ${sizeArray[0]}w, `;
                                                });
                                            }
                                            let colorValue = key.toLowerCase().trim();
                                            if (colorValue === 'black') {
                                                    active = "active";
                                                    
                                                    const productCard = productDataElements.closest('.product-card');
                                                    const currentVariantId = productCard.querySelector('#current_variant_id');
                                                    currentVariantId.value = variantId;
                                                    const primaryImage = productCard.querySelector('.product-primary-image');
                                                    const secondaryImage = productCard.querySelector('.product-secondary-image');
                                                    const productCardTitleHref = productCard.querySelector('.product-card-title');
                                                    const productCardImgHref = productCard.querySelector('.product-featured-image a');
                                                    if (variantImage) {
                                                        let newPrimarySrcset = variantImage || '';
                                                        if (!newPrimarySrcset) {
                                                            newPrimarySrcset = '/cdn/shop/t/1/assets/natoriplaceholder.png';
                                                        }
                                                        if (primaryImage) {
                                                        primaryImage.srcset = newPrimarySrcset;
                                                        primaryImage.src = newPrimarySrcset.split(' ')[0];
                                                        }
                                                    }
                                                    if (secondaryImagesrc) {
                                                        const newSecondarySrcset = secondaryImagesrc;
                                                        if (secondaryImage) {
                                                        secondaryImage.srcset = newSecondarySrcset;
                                                        secondaryImage.src = newSecondarySrcset.split(' ')[0];
                                                        }
                                                    }
                                                    if (variantUrl) {
                                                        const product_handle = variantUrl;
                                                        if (product_handle) {
                                                            productCardTitleHref.setAttribute('href', product_handle);
                                                            productCardImgHref.setAttribute('href', product_handle);
                                                        }
                                                    }

                                                }
                                            const customColorIndex = keyArray.indexOf(colorValue);
                                            if (customColorIndex > -1) {
                                                colorValue = valArray[customColorIndex];
                                            }
                                            let bgValue = false;
                                            const swatchColor = product.variantSwatchColor?.value;
                                            if (swatchColor) {
                                                const swatchParts = swatchColor.split("-");
                                                const lastPart =
                                                    swatchParts[swatchParts.length - 1].trim();
                                                if (lastPart.includes("#")) {
                                                    colorValue = lastPart;
                                                } else {
                                                    bgValue = lastPart;
                                                    colorValue = "var(--bg-body)";
                                                }
                                            } else {
                                                if (colorValue.includes(".")) {
                                                    bgValue = colorValue;
                                                    colorValue = "var(--bg-body)";
                                                }
                                            }
                                            const shopDomain = window.location.hostname;
                                            const bgImageUrl = bgValue? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');`: "";
                                            swatchHtml += `
                                                        <div class="product-card-swatch ${active}"
                                                            style="--option-color: ${colorValue}; ${bgImageUrl}" 
                                                            data-srcset-2="${secondaryImagesrc}" 
                                                            data-srcset="${variantImage}"
                                                            data-href="${variantUrl}"
                                                            data-quan="${productQuan}"
                                                            data-variant_id="${variantId}">
                                                            <span class="visually-hidden">${key}</span>
                                                        </div>
                                                    `;
                                            if (productDataElements) {
                                                const existingSwatches = productDataElements.querySelectorAll( ".product-card-swatch" );
                                                const isSwatchExists = existingSwatches.length > 0 && productDataElements.querySelector( `.product-card-swatch[data-href="${variantUrl}"]` );
                                                if (!isSwatchExists && existingSwatches.length < 6) {
                                                    productDataElements.insertAdjacentHTML("beforeend",swatchHtml);
                                                    counter.count++;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        console.log('Number of Products', counter);
                        if (counter.count >= 6) break;
                        customVarList.push(variantCustomId);
                        
                    }
                }
            }
        
            storedVariants[productId] = { variants: customVarList };
            //sessionStorage.setItem("natoriCustomVariants",JSON.stringify(storedVariants));
        
            if (uniqueColors.size > 5 && counter.count > 5) {
                const moreButtonHtml = `<div class="morebtn"><a href="${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
                productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
            }
            
        }
    };
    if (window.location.pathname.includes("/bra-quiz-results")) {
        const productCards = document.querySelectorAll(".product-card-swatch");
        let productCounter = 0;
        for (const card of productCards) {
            const prodOldSwatches = card.querySelector(".product-card-swatches");
            if (prodOldSwatches) {
                prodOldSwatches.innerHTML = "";
            }
        
            const productId = card.getAttribute("data-product-id");
            const productStyleNo = card.getAttribute("data-style-no");
            const color_settings = window["settings"];
            const settings = window[`settings_${productId}`];
        
            const customColorsArray = color_settings.color_swatches.split(",").map((color) => {
                const [key, value] = color.split(":").map((part) => part.trim());
                return { key: key.toLowerCase(), value: value || "" };
            });
        
            const keyArray = customColorsArray.map((color) => color.key);
            const valArray = customColorsArray.map((color) => color.value);
        
            let productDetails;
            try {
                productDetails = await fetchProductDetails(productStyleNo);
            } catch (error) {
                console.error("Error fetching product details:", error);
                continue;
            }
        
            let uniqueColors = new Map();
            let counter = { count: 0 };
            for (const productDetail of productDetails) {
                const productAvailable = productDetail.totalInventory > 0;
                const discontinued = productDetail?.discontinued?.value === "true";
                if (productDetail && !discontinued && productAvailable) {
                    let primaryImagesrc = "";
                    let secondaryImagesrc = "";
                    if ( productDetail && productDetail.images && productDetail.images.edges ) {
                        const images = productDetail.images.edges.map((edge) => edge.node);
                        images.forEach((image, index) => {
                            if (index === 0) {
                                primaryImagesrc = image.src;
                            }
                            if (index === 1) {
                                secondaryImagesrc = image.src;
                            }
                        });
                    }
                    await processProductDetails(
                        productDetail,
                        keyArray,
                        valArray,
                        settings.featured_image_id,
                        document.getElementById("swatch_section_" + productId),
                        productId,
                        primaryImagesrc,
                        secondaryImagesrc,
                        settings.custom_handle,
                        uniqueColors,
                        counter,
                        productAvailable
                    );
                    if (counter.count >= 6) break;
                }
            }
            var swatchSection = document.getElementById("swatch_section_" + productId);
            if (swatchSection) {
                await enableDigiohSwatch();
                //swatchSection.parentNode.parentNode.parentNode.enableSwatches();
            }
            if(counter.count == 0 && card){
                const productCardDiv = card.closest('li.column');
                productCardDiv.remove();
            }
            productCounter = (productCounter + counter.count);
        }
        if(productCounter == 0){
            let Brasize = document.querySelector(".bra-sizes");
            Brasize.remove();
            let ProductGridContainer = document.getElementById("ProductGridContainer");
            ProductGridContainer.innerHTML =`<div class="emtpy-result"><h1>Thank you for taking our quiz!</h1>
                    <p>
                        Based on your responses, it looks like your size falls outside our current range.
                    </p>
                    <p>
                        While we don’t currently have your bra size available, we invite you to explore the <b>World of Natori</b> — from ready-to-wear, lingerie, sleepwear, and legwear to fine jewelry and home textiles — and discover pieces that help you feel your best from the inside out.
                    </p>
                    <p class="email">
                        For personalized size guidance or recommendations, our team would love to assist — reach out anytime at
                        <a style="color:blue" href="mailto:help@natori.com">help@natori.com</a>
                    </p></div>`;
                    let referenceSection = ProductGridContainer.closest('.shopify-section');
            const previousSection = referenceSection.previousElementSibling;

            // Check if the previous element exists and has the .shopify-section class
            if (previousSection && previousSection.classList.contains('shopify-section')) {
                previousSection.style.display = 'none'; // Or use 'visibility = "hidden"'
            }
            console.log('Total Product:', productCounter)
        }
        document.querySelector('#main-content').classList.remove('loading');
    } else {
        setTimeout(async () => {
            const productCards = document.querySelectorAll(".product-card-swatch");
        
            for (const card of productCards) {
                const prodOldSwatches = card.querySelector(".product-card-swatches");
                if (prodOldSwatches) {
                    prodOldSwatches.innerHTML = "";
                }
        
                const productId = card.getAttribute("data-product-id");
                const productStyleNo = card.getAttribute("data-style-no");
                const color_settings = window["settings"];
                const settings = window[`settings_${productId}`];
        
                const customColorsArray = color_settings.color_swatches.split(",").map((color) => {
                    const [key, value] = color.split(":").map((part) => part.trim());
                    return { key: key.toLowerCase(), value: value || "" };
                });
        
                const keyArray = customColorsArray.map((color) => color.key);
                const valArray = customColorsArray.map((color) => color.value);
        
                let productDetails;
                try {
                    productDetails = await fetchProductDetails(productStyleNo);
                } catch (error) {
                    console.error("Error fetching product details:", error);
                    continue;
                }
        
                let uniqueColors = new Map();
                let counter = { count: 0 };
                for (const productDetail of productDetails) {
                    const productAvailable = productDetail.totalInventory > 0;
                    const discontinued = productDetail?.discontinued?.value === "true";
                    if (productDetail && !discontinued && productAvailable) {
                        let primaryImagesrc = "";
                        let secondaryImagesrc = "";
                        if ( productDetail && productDetail.images && productDetail.images.edges ) {
                            const images = productDetail.images.edges.map(
                                (edge) => edge.node
                            );
                            images.forEach((image, index) => {
                                if (index === 0) {
                                primaryImagesrc = image.src;
                                }
                                if (index === 1) {
                                secondaryImagesrc = image.src;
                                }
                            });
                        }
                        await processProductDetails(
                            productDetail,
                            keyArray,
                            valArray,
                            settings.featured_image_id,
                            document.getElementById("swatch_section_" + productId),
                            productId,
                            primaryImagesrc,
                            secondaryImagesrc,
                            settings.custom_handle,
                            uniqueColors,
                            counter,
                            productAvailable
                        );
                        if (counter.count >= 6) break;
                    }
                }
                var swatchSection = document.getElementById("swatch_section_" + productId);
                if (swatchSection) {
                    await enableDigiohSwatch();
                //swatchSection.parentNode.parentNode.parentNode.enableSwatches();
                }
            }
        }, 2000);
    }
});
  